import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';

// Importing translations
import transration_en from "./en.json";
import transration_ja from "./ja.json";

const resources = {
    en: {
        translation: transration_en,
    },
    ja: {
        translation: transration_ja,
    },
    };

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: "ja",
        interpolation: {
            escapeValue: false,
        },
        detection: {
          order: ['cookie', 'localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
          checkWhitelist: true
        },
        supportedLngs : ['en', 'ja'],
    });

export default i18n;